import { type ArticleType } from '@xing-com/crate-articles-article-editor';

import ArticleCoverImage from './article-cover-image';
import ArticleCoverVideo from './article-cover-video';

type ArticleCoverProps = {
  article: ArticleType;
};

const ArticleCover: React.FC<ArticleCoverProps> = ({ article }) => {
  if (article.coverType === 'image') {
    return (
      <ArticleCoverImage
        coverImageURL={article?.headerImageURL}
        caption={article?.headerImageCaption}
      />
    );
  } else if (article.coverType === 'video') {
    return (
      <ArticleCoverVideo
        videoRef={article?.headerVideoRef}
        caption={article.headerVideoCaption}
      />
    );
  }

  return null;
};

export default ArticleCover;
